<elder-shell class="full">
  <!-- Toolbar default for right column -->
  <ng-template elderToolbarColumn="right" [elderToolbarDefault]="true">
    <div class="layout-row place-end-center">
      <elder-language-switcher [slimMode]="true"></elder-language-switcher>
    </div>
  </ng-template>

  <!-- Left Side Content -->
  <div *elderShellSideLeft class="full layout-col">
    <!-- App Header -->
    <elder-app-header
      title="{{ 'main.title' | translate }}"
      svgIcon="utop-logo"
      version="{{ version }}"
    >
      <elder-expand-toggle-button class="p-sm" [elderTogglePanelTrigger]="navMenu">
        @if (principal | async; as principal) {
          <div class="layout-col p-sm">
            <div>{{ principal.name }}</div>
            <div class="mat-caption">{{ principal.username }}</div>
          </div>
        }
      </elder-expand-toggle-button>
    </elder-app-header>

    <elder-toggle-panel class="flex elder-main-nav-panel" #navMenu="elderTogglePanel">
      <!-- Primary Navigation -->
      <app-main-nav-menu class="flex" *elderTogglePanelPrimary></app-main-nav-menu>

      <!-- Secondary Navigation -->
      <elder-nav-list *elderTogglePanelSecondary class="flex">
        @if (principal | async) {
          <elder-nav-link icon="account_circle" title="Account" href="{{ accountUrl }}">
          </elder-nav-link>
        }

        @if (principal | async; as principal) {
          <elder-nav-link
            icon="exit_to_app"
            title="Logout {{ principal.username }}"
            (click)="logout()"
          >
          </elder-nav-link>
        }

        <mat-divider></mat-divider>

        <elder-appearance-settings></elder-appearance-settings>
      </elder-nav-list>
    </elder-toggle-panel>
  </div>
  <ng-template elderShellStaticNavSlot>
    <app-main-nav-menu elderRailNav></app-main-nav-menu>
  </ng-template>
</elder-shell>
